const app_env: string | undefined = process.env.REACT_APP_ENV;

let isLocal = false;
if (!app_env) {
  isLocal = true;
}

export const envName = app_env || "prod";
export const isDev: boolean = !isLocal && app_env === "dev";
export const isTest: boolean = !isLocal && app_env === "test";
export const isUat: boolean = !isLocal && app_env === "uat";
export const isProd: boolean =
  app_env === "prod" ||
  app_env === "production" ||
  (!isLocal && !isDev && !isUat && !isTest);
const ua = navigator.userAgent.toLowerCase();



export const env: ENV = {
  envName: envName,
  isDev: isDev,
  isTest: isTest,
  isUat: isUat,
  isProd: isProd,
  isMobile: /mobile/.test(ua),
};
